import { useEffect, useState } from 'react';
import type { AuditLog } from '@torapon/shared';
import { api, HttpError } from '../lib/api';
import { useNames } from '../lib/directory';
import { fmtDateTime } from '../lib/format';

/** 操作の名前（操作ログの action） */
const ACTION: Record<string, string> = {
  'drivers.create': 'ドライバーを追加', 'staff.create': 'スタッフを追加', 'places.create': '場所を追加', 'places.update': '場所を直す',
  'batches.create': '配送指示を送信・保存', 'batches.reorder': '回る順番を変更', 'deliveries.cancel': '配送を取り消し', 'deliveries.reassign': '配送を付け替え',
  'roll-calls.confirm': '点呼を確認', 'roll-calls.list': '点呼を見る', 'drivers.view': 'ドライバー詳細を見る', 'shifts.force-end': '勤務を終了させる',
  'vehicles.create': '車両を追加', 'detectors.create': '検知器を追加', 'alerts.ack': '警告を対応済みに', 'issues.resolve': '問題報告に対応', 'photos.list': '写真の一覧を見る', 'photos.view': '写真を見る', 'dev-mode.unlock': '開発者モードを開く', 'dev-mode.flags': '開発者モードの設定を変更', 'dev-mode.reset': '開発者モードでドライバーを勤務前に戻す', 'dev-mode.simulate': '開発者モードで状態を作る', 'invites.send': '招待メールを送信', 'devices.approve': '端末を承認', 'devices.revoke': '端末を解除', 'drivers.paper-consent': '紙の同意を記録', 'clients.list': '荷主の一覧を見る', 'clients.create': '荷主を追加', 'clients.update': '荷主を直す', 'templates.create': 'ひな形を保存', 'templates.delete': 'ひな形を消す',
  'records.roll-calls': '点呼記録簿を見る', 'records.daily-reports': '運転日報を見る', 'records.work-hours': '労働時間を見る', 'audit-logs.view': '操作ログを見る',
};

/** 操作ログ（仕様書「記録と監視」：だれが・いつ・何をしたか。1 年保存） */
export function AuditPage() {
  const names = useNames();
  const [logs, setLogs] = useState<AuditLog[] | null>(null);
  const [next, setNext] = useState<string | null>(null);
  const [err, setErr] = useState('');
  const load = (before?: string) => api.get<{ logs: AuditLog[]; next: string | null }>(`/v1/office/audit-logs${before ? `?before=${encodeURIComponent(before)}` : ''}`)
    .then((r) => { setLogs((x) => (before ? [...(x ?? []), ...r.logs] : r.logs)); setNext(r.next); })
    .catch((e) => setErr(e instanceof HttpError ? e.message : '読み込めませんでした'));
  useEffect(() => { void load(); }, []);
  return (
    <div className="page" style={{ display: 'grid', gap: 12 }}>
      {err && <p className="err" role="alert">{err}</p>}
      <div className="panel">
        <table>
          <thead><tr><th>日時</th><th>した人</th><th>操作</th><th>対象</th></tr></thead>
          <tbody>
            {logs === null ? <tr><td colSpan={4} className="muted">読み込み中…</td></tr>
              : logs.length === 0 ? <tr><td colSpan={4} className="muted">まだ記録がありません</td></tr>
              : logs.map((l) => (
                <tr key={l.id}><td className="num">{fmtDateTime(l.at)}</td><td>{names.staff(l.actor) === '—' ? names.driver(l.actor) : names.staff(l.actor)}</td><td>{ACTION[l.action] ?? l.action}</td><td className="num" style={{ fontSize: 12, overflowWrap: 'anywhere' }}>{l.target ?? '—'}</td></tr>
              ))}
          </tbody>
        </table>
      </div>
      {next && <button className="btn" style={{ justifySelf: 'center' }} onClick={() => load(next)}>もっと見る</button>}
    </div>
  );
}
